/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Seconds } from '@wit/vtv-x-foundation-lib';
import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Hook to track stream seeking state
 * workarounds slow progress updates while seeking
 */
export function useSeekingStream(progress: Seconds): [boolean, (state: boolean) => void] {
  const [seekingStream, setSeekingStream] = useState(false);
  const disableSeekingStreamOnNextProgressUpdate = useRef(false);

  useEffect(() => {
    if (disableSeekingStreamOnNextProgressUpdate.current === true) {
      disableSeekingStreamOnNextProgressUpdate.current = false;
      setSeekingStream(false);
    }
  }, [progress]);

  const setState = useCallback((value: boolean) => {
    if (value) {
      setSeekingStream(true);
    } else {
      // Disable the seeking stream on the next progress change
      disableSeekingStreamOnNextProgressUpdate.current = true;
    }
  }, []);

  return [seekingStream, setState];
}
